<template>
    <tbody class="table-font">
        <tr >
            <td>{{ (currentpage - 1) * noofrec + (index + 1) }} </td>
            <!-- <td>
                <span v-if="item.loanemi!=null && item.loanemi.loanaccount!=null">{{item.loanemi.loanaccount.manualid}}</span>
            </td> -->
            <td>{{ item.name }}</td>
            <td>{{item.address}} </td>
            <td> {{item.mobileno}}</td>
            <td>{{item.altmobileno}}</td>
            <td>{{ getMasterLabelByType(item.gender,MASTER_GENDER)}}</td>
            <td>{{item.experience }} years</td>
            <td>{{ getMasterLabelByType(item.qualification,QUALIFICATION_TYPE)}}</td>
            <td>{{ getMasterLabelByType(item.position,APPLY_FOR_POSITION) }}</td>
            <td>
                {{ item.date!=null?moment(item.date).format("DD-MM-YYYY"):'---' }}
            </td>
            <td>
                {{ jobremark(item.remark) }}
            </td>
            <td class="text-center" @dblclick="statusmethod(item)" @keyup.enter="statusmethod(item)">
                <select v-if="statusfield" class="form-control form-cascade-control input-small" v-model="item.status" name="status" @change="statusmethod(item)">
                        <option value="0">SELECT</option>
                        <option value="1">SHORT LISTED</option>
                        <option value="2">APPOINTED</option>
                        <option value="3">REJECTED</option>
                        <option value="4">TERMINATED</option>
                </select>
                {{  jobstatus(item.status)}}
            </td>
            <td>
                {{ item.referby }}
            </td>
            <!-- <td v-if="loginusercheck(165)"><button class="btn btn-success" type="button" @click="edit(item)"><i class='bx bx-edit'></i></button></td> -->
            <td><button class="btn btn-primary" type="button" @click="desc=!desc">Description</button></td>
        </tr>
        <tr v-if="desc" >
            <td colspan="10">Desc :{{item.description  }}</td>
        </tr>
        <tr v-if="visitcomments">
            <td colspan="16">
                <job-conversation :item="item"></job-conversation>
            </td>
        </tr>
    </tbody>
</template>
<script>
import Constants from "../../components/utilities/Constants.vue";
import moment from "moment";
import JobConversation from "./JobConversation.vue";
import { mapGetters } from "vuex";
export default {
    components:[JobConversation],
    mixins:[Constants],   
    props:['item','index','currentpage','noofrec'],
    data() {
        return {
            moment:moment,
            accounttype:0,
            commentlist:[],
            danger:false,
            desc:false,
            statusfield:false
        }
    },
    computed: {
        ...mapGetters(["attributes",'viewno','loggedinuser'])
    },
    
    methods: {
        refresh(){
            this.$parent.refresh();
        },
        edit(item){
            this.$store.commit('assignjoblist',item)
            this.$store.commit('assignviewno',2)
        },
        statusmethod(item){
            this.statusfield=!this.statusfield
            let param={id:item.id,column:"status",value:item.status}
            this.$http.post('api/recruit/updatefield',param)
            .then((response) => this.processUpdateResponse(response.data))
            .catch((err) => {
                console.log('', err)
            });
        },
        processUpdateResponse(){
            this.$parent.refresh();
        }
    },
}
</script>